import { SET_MOBILE_SIDEBAR_VIEW } from '../actions';
import { VIEWS } from '../constants';

export default (state, action) => {
  if (!state) {
    return {
      currentView: VIEWS.ROOT,
    };
  }

  switch (action.type) {
    case SET_MOBILE_SIDEBAR_VIEW:
      return {
        ...state,
        currentView: action.currentView,
      };

    default:
      break;
  }

  return state;
};
